define('viewmodels/tournaments/TournamentCampaignViewModel',[
    'knockout',
    'underscore'
], function (ko, _) {

    /* eslint-disable max-statements */
    function TournamentCampaignViewModel (
        TournamentViewModel,
        generalPage,
        specificPage,
        campaign
    ) {
        var self = this;

        function mapTournamentModelToViewModel (tournamentModel) {
            return new TournamentViewModel(self, tournamentModel);
        }

        self.campaignTitle = specificPage.findFieldByName('campaign_title');
        self.dashboardText = specificPage.findFieldByName('dashboard_text');
        self.dashboardButtonText = specificPage.findFieldByName('dashboard_button');
        self.dashboardBackgroundImageUrl = specificPage.findFieldByName('dashboard_background');

        self.previousWinnersTabTitle = generalPage.findFieldByName('previous_winners_tab_title');

        self.instructionsTabTitle = generalPage.findFieldByName('instructions_tab_title');
        self.instructionsText = generalPage.findFieldByName('instructions_text');
        self.instructionsReadMoreButtonText = generalPage.findFieldByName('instructions_read_more_button');
        self.instructionsBackgroundImageUrl = specificPage.findFieldByName('instructions_background');

        self.rulesTitle = specificPage.findFieldByName('rules_title');
        self.rules = specificPage.findFieldByName('rules_content').withFallback([]);

        self.howItWorksTitle = specificPage.findFieldByName('how_it_works_title');
        self.howItWorks = specificPage.findFieldByName('how_it_works_content').withFallback([]);

        self.pointsInfoTitle = specificPage.findFieldByName('points_info_title');
        self.pointsInfo = specificPage.findFieldByName('points_info_content').withFallback([]);

        self.termsText = specificPage.findFieldByName('terms_text');

        self.showMoreReelRaces = generalPage.findFieldByName('show_more_reel_races');
        self.goToScheduleText = generalPage.findFieldByName('go_to_schedule_text');

        self.openItemInSchedule = function (item, items) {
            _.forEach(items(), function (tournament) {
                if (tournament === item) {
                    tournament.showDetailedView(true);
                    return;
                }
                tournament.showDetailedView(false);
            });
        };

        self.scheduleTabTitle = generalPage.findFieldByName('schedule_tab_title');
        self.schedule = campaign.schedule.pipe(function (schedule) {
            return schedule.map(mapTournamentModelToViewModel);
        });

        self.numberOfBatches = ko.observable(1);
        self.batchSize = 10;
        self.tournamentsToShow = ko.pureComputed(function () {
            // Drop the first one as we don't want to show the closest race.
            return _.drop(_.take(self.schedule(), self.numberOfBatches() * self.batchSize), 1);
        });
        self.addBatch = function () {
            if (self.numberOfBatches() * self.batchSize < self.schedule().length) {
                self.numberOfBatches(self.numberOfBatches() + 1);
            }
        };

        self.scheduleTomorrow = generalPage.findFieldByName('schedule_tomorrow');

        self.isFirstTournamentOfTheDay = function (tournamentViewModel) {
            var schedule = self.schedule(),
                i = _.findIndex(self.schedule(), tournamentViewModel),
                previous = schedule[i - 1];

            return !previous || !previous.startTime.isSame(tournamentViewModel.startTime, 'day');
        };

        self.tournamentTrackerBackgroundImageUrl = specificPage.findFieldByName('game_page_background');

        self.currentTournament = campaign.currentTournament.pipe(_.skipFalsy(mapTournamentModelToViewModel));
        self.nextTournament = campaign.nextTournament.pipe(_.skipFalsy(mapTournamentModelToViewModel));

        self.promotedTournament = campaign.promotedTournament
                .pipe(function (promotedTournamentModel) {

                    if (promotedTournamentModel === campaign.nextTournament()) {
                        return null;
                    }

                    return promotedTournamentModel;
                })
                .pipe(_.skipFalsy(mapTournamentModelToViewModel));

        self.previousTournament = campaign.previousTournament.pipe(
            _.skipFalsy(mapTournamentModelToViewModel)
        );

        self.previousTournaments = campaign.previousTournaments.pipe(function (previousTournaments) {
            return previousTournaments.reverse().map(mapTournamentModelToViewModel);
        });

        self.recommendedGamesTitle = generalPage.findFieldByName('recommended_games_title');
        self.recommendedGames = specificPage.findFieldByName('recommended_games').withFallback([]);

        self.promotedTournamentBackgroundImageUrl = specificPage
            .findFieldByName('promoted_tournament_background');

        self.currentPlayerParticipatingInCurrentTournament = ko.pureComputed(function () {
            return !!campaign.currentTournament() && campaign.currentTournament().isParticipating();
        });

        self.howDoesItWorkText = generalPage.findFieldByName('leaderboard_in_progress_button');

    }
    /* eslint-enable max-statements */

    return TournamentCampaignViewModel;

});

